import axios from 'axios'
import AuthService from "./auth/auth.service";
//Wrap custom functions in an object to export it to Vue.js
var customFunctions = {

  getColor(duedate) {
    // To set two dates to two variables
    if(duedate == '-')
    {
      return "success";
    } 
    var date1 = new Date();
    var date2 = new Date(duedate);

    // To calculate the time difference of two dates
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    if (Difference_In_Days < 0) return "error";
    // else if (Difference_In_Days > 10) return "success";
    else if (Difference_In_Days > 5) return "info";
    else if (Difference_In_Days > 0) return "warning";
    else return "info";
  },



  uploadInputForm(Templatefile, selectedTask) {
    // FormData を利用して File を POST する
    let formData = new FormData();
    formData.append('uploadFile', Templatefile);
    formData.append('template', selectedTask.name);
    formData.append('collectionUnit', selectedTask.coln_unit);
    formData.append('actionType', 'Upload');
    let config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    axios
      .post('http://localhost:5000/handlefile', formData, config)
      .then(function (response) {
        // response 処理
        //this.message = response.data.message;

      })
      .catch(function (error) {
        // error 処理
        //alert("Error: "+error);
        alert("File Uploaded");
      })
  },

  getFormData(Templatefile, selectedTask, actionType) {
    let formData = new FormData();
    formData.append('uploadFile', Templatefile);
    formData.append('template', selectedTask.name);
    formData.append('collectionUnit', selectedTask.coln_unit);
    formData.append('actionType', actionType);
    return formData;
  },

  downloadInputForm(response, filename) {
    try {
      //console.log(response.headers);
      const url = window.URL
        .createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      //link.setAttribute('download', 'temp.xlsm');
      if (!filename) {
        filename = response.headers["content-disposition"].substring(21).replace(/^"|"$/g, '');
      }
      //console.log('filename: ' + filename);
      link.setAttribute('download', filename);
      //console.log(link);
      document.body.appendChild(link);
      link.click();
    }
    catch (ex) {
      console.log("Error : " + ex);
    }
  },

  GetPhotoURL(response) {
    try {

      const url = window.URL || window.webkitURL;
      const Photourl = url.createObjectURL(response);

      return Photourl;

    }
    catch (ex) {
      console.log("Error : " + ex);
    }
  },

  generateRandomColors(number) {
    
    const pSBC=(p,c0,c1,l)=>{
      let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
      if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
      if(!this.pSBCr)this.pSBCr=(d)=>{
          let n=d.length,x={};
          if(n>9){
              [r,g,b,a]=d=d.split(","),n=d.length;
              if(n<3||n>4)return null;
              x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
          }else{
              if(n==8||n==6||n<4)return null;
              if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
              d=i(d.slice(1),16);
              if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
              else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
          }return x};
      h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
      if(!f||!t)return null;
      if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
      else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
      a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
      if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
      else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
  }

    /*
    This generates colors using the following algorithm:
    Each time you create a color:
      Create a random, but attractive, color{
        Red, Green, and Blue are set to random luminosity.
        One random value is reduced significantly to prevent grayscale.
        Another is increased by a random amount up to 100%.
        They are mapped to a random total luminosity in a medium-high range (bright but not white).
      }
      Check for similarity to other colors{
        Check if the colors are very close together in value.
        Check if the colors are of similar hue and saturation.
        Check if the colors are of similar luminosity.
        If the random color is too similar to another,
        and there is still a good opportunity to change it:
          Change the hue of the random color and try again.
      }
      Output array of all colors generated
    */
    //if we've passed preloaded colors and they're in hex format
    if (typeof (arguments[1]) != 'undefined' && arguments[1].constructor == Array && arguments[1][0] && arguments[1][0].constructor != Array) {
      for (var i = 0; i < arguments[1].length; i++) { //for all the passed colors
        var vals = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(arguments[1][i]); //get RGB values
        arguments[1][i] = [parseInt(vals[1], 16), parseInt(vals[2], 16), parseInt(vals[3], 16)]; //and convert them to base 10
      }
    }
    var loadedColors = typeof (arguments[1]) == 'undefined' ? [] : arguments[1];//predefine colors in the set
    number = number + loadedColors.length;//reset number to include the colors already passed
    var lastLoadedReduction = Math.floor(Math.random() * 3);//set a random value to be the first to decrease
    let rgbToHSL = function (rgb) {//converts [r,g,b] into [h,s,l]
      var r = rgb[0], g = rgb[1], b = rgb[2], cMax = Math.max(r, g, b), cMin = Math.min(r, g, b), delta = cMax - cMin, l = (cMax + cMin) / 2, h = 0, s = 0; if (delta == 0) h = 0; else if (cMax == r) h = 60 * ((g - b) / delta % 6); else if (cMax == g) h = 60 * ((b - r) / delta + 2); else h = 60 * ((r - g) / delta + 4); if (delta == 0) s = 0; else s = delta / (1 - Math.abs(2 * l - 1)); return [h, s, l]
    }, hslToRGB = function (hsl) {//converts [h,s,l] into [r,g,b]
      var h = hsl[0], s = hsl[1], l = hsl[2], c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs(h / 60 % 2 - 1)), m = l - c / 2, r, g, b; if (h < 60) { r = c; g = x; b = 0 } else if (h < 120) { r = x; g = c; b = 0 } else if (h < 180) { r = 0; g = c; b = x } else if (h < 240) { r = 0; g = x; b = c } else if (h < 300) { r = x; g = 0; b = c } else { r = c; g = 0; b = x } return [r, g, b]
    }, shiftHue = function (rgb, degree) {//shifts [r,g,b] by a number of degrees
      var hsl = rgbToHSL(rgb); //convert to hue/saturation/luminosity to modify hue
      hsl[0] += degree; //increment the hue
      if (hsl[0] > 360) { //if it's too high
        hsl[0] -= 360 //decrease it mod 360
      } else if (hsl[0] < 0) { //if it's too low
        hsl[0] += 360 //increase it mod 360
      }
      return hslToRGB(hsl); //convert back to rgb
    }, differenceRecursions = {//stores recursion data, so if all else fails we can use one of the hues already generated
      differences: [],//used to calculate the most distant hue
      values: []//used to store the actual colors
    }, fixDifference = function (color) {//recursively asserts that the current color is distinctive
      if (differenceRecursions.values.length > 23) {//first, check if this is the 25th recursion or higher. (can we try any more unique hues?)
        //if so, get the biggest value in differences that we have and its corresponding value
        var ret = differenceRecursions.values[differenceRecursions.differences.indexOf(Math.max.apply(null, differenceRecursions.differences))];
        differenceRecursions = { differences: [], values: [] }; //then reset the recursions array, because we're done now
        return ret; //and then return up the recursion chain
      } //okay, so we still have some hues to try.
      var differences = []; //an array of the "difference" numbers we're going to generate.
      for (var i = 0; i < loadedColors.length; i++) { //for all the colors we've generated so far
        var difference = loadedColors[i].map(function (value, index) { //for each value (red,green,blue)
          return Math.abs(value - color[index]) //replace it with the difference in that value between the two colors
        });
        var sumFunction = function (sum, value) { //function for adding up arrays
          return sum + value
        };
        var sumDifference = difference.reduce(sumFunction); //add up the difference array
        var loadedColorLuminosity = loadedColors[i].reduce(sumFunction);//get the total luminosity of the already generated color
        var currentColorLuminosity = color.reduce(sumFunction); //get the total luminosity of the current color
        var lumDifference = Math.abs(loadedColorLuminosity - currentColorLuminosity); //get the difference in luminosity between the two
        //how close are these two colors to being the same luminosity and saturation?
        var differenceRange = Math.max.apply(null, difference) - Math.min.apply(null, difference);
        var luminosityFactor = 50; //how much difference in luminosity the human eye should be able to detect easily
        var rangeFactor = 75; //how much difference in luminosity and saturation the human eye should be able to dect easily
        if (luminosityFactor / (lumDifference + 1) * rangeFactor / (differenceRange + 1) > 1) { //if there's a problem with range or luminosity
          //set the biggest difference for these colors to be whatever is most significant
          differences.push(Math.min(differenceRange + lumDifference, sumDifference));
        }
        differences.push(sumDifference); //otherwise output the raw difference in RGB values
      }
      var breakdownAt = 64, //if you're generating this many colors or more, don't try so hard to make unique hues, because you might fail.
        breakdownFactor = 25, //how much should additional colors decrease the acceptable difference
        shiftByDegrees = 15, //how many degrees of hue should we iterate through if this fails
        acceptableDifference = 250, //how much difference is unacceptable between colors
        breakVal = loadedColors.length / number * (number - breakdownAt), //break down progressively (if it's the second color, you can still make it a unique hue)
        totalDifference = Math.min.apply(null, differences); //get the color closest to the current color
      if (totalDifference > acceptableDifference - (breakVal < 0 ? 0 : breakVal) * breakdownFactor) { //if the current color is acceptable
        differenceRecursions = { differences: [], values: [] } //reset the recursions object, because we're done
        return color; //and return that color
      } //otherwise the current color is too much like another
      //start by adding this recursion's data into the recursions object
      differenceRecursions.differences.push(totalDifference);
      differenceRecursions.values.push(color);
      color = shiftHue(color, shiftByDegrees); //then increment the color's hue
      return fixDifference(color); //and try again
    }, color = function () { //generate a random color
      var scale = function (x) { //maps [0,1] to [300,510]
        return x * 210 + 300 //(no brighter than #ff0 or #0ff or #f0f, but still pretty bright)
      }, randVal = function () { //random value between 300 and 510
        return Math.floor(scale(Math.random()))
      }, luminosity = randVal(), //random luminosity
        red = randVal(), //random color values
        green = randVal(), //these could be any random integer but we'll use the same function as for luminosity
        blue = randVal(),
        rescale, //we'll define this later
        thisColor = [red, green, blue], //an array of the random values
        /*
        #ff0 and #9e0 are not the same colors, but they are on the same range of the spectrum, namely without blue.
        Try to choose colors such that consecutive colors are on different ranges of the spectrum.
        This shouldn't always happen, but it should happen more often then not.
        Using a factor of 2.3, we'll only get the same range of spectrum 15% of the time.
        */
        valueToReduce = Math.floor(lastLoadedReduction + 1 + Math.random() * 2.3) % 3, //which value to reduce
        /*
        Because 300 and 510 are fairly close in reference to zero,
        increase one of the remaining values by some arbitrary percent betweeen 0% and 100%,
        so that our remaining two values can be somewhat different.
        */
        valueToIncrease = Math.floor(valueToIncrease + 1 + Math.random() * 2) % 3, //which value to increase (not the one we reduced)
        increaseBy = Math.random() + 1; //how much to increase it by
      lastLoadedReduction = valueToReduce; //next time we make a color, try not to reduce the same one
      thisColor[valueToReduce] = Math.floor(thisColor[valueToReduce] / 16); //reduce one of the values
      thisColor[valueToIncrease] = Math.ceil(thisColor[valueToIncrease] * increaseBy) //increase one of the values
      rescale = function (x) { //now, rescale the random numbers so that our output color has the luminosity we want
        return x * luminosity / thisColor.reduce(function (a, b) { return a + b }) //sum red, green, and blue to get the total luminosity
      };
      thisColor = fixDifference(thisColor.map(function (a) { return rescale(a) })); //fix the hue so that our color is recognizable
      if (Math.max.apply(null, thisColor) > 255) { //if any values are too large
        rescale = function (x) { //rescale the numbers to legitimate hex values
          return x * 255 / Math.max.apply(null, thisColor)
        }
        thisColor = thisColor.map(function (a) { return rescale(a) });
      }
      return thisColor;
    };
    for (var k = loadedColors.length; k < number; k++) { //Start with our predefined colors or 0, and generate the correct number of colors.
      loadedColors.push(color().map(function (value) { //for each new color
        return Math.round(value); //round RGB values to integers
      }));
    }
    //then, after you've made all your colors, convert them to hex codes and return them.
    return loadedColors.map(function (color) {
      var hx = function (c) { //for each value
        var h = c.toString(16);//then convert it to a hex code
        return h.length < 2 ? '0' + h : h//and assert that it's two digits
      }
      return pSBC ( 0.2, "#" + hx(color[0]) + hx(color[1]) + hx(color[2])); //then return the hex code
    });
  },


  
 IsAuthorized(authService,user,store,objAuth)
{
  
    try {
       authService
        .getToken()
        .then((token) => {
         axios(process.env.VUE_APP_AUTH_SERVICE + "Authorize", {
            headers: {
              Authorization: "Bearer " + token.accessToken,
            },
            params: {
              tenant: process.env.VUE_APP_TENANT,
              userId: user.userName,
              action: objAuth.actionName,              
            },
          })
            .then((result) => {
              //console.log(objAuth.actionName +" - Result :-> "+result.status);
              objAuth.result=true;
              store.commit("SetActions",objAuth);                    
            })
            .catch((error) => {
              //console.log(objAuth.actionName +" - Result :-> "+error);             
            });
        })
        .catch((error) => {
          //console.log("ERROR : " + error);          
        });
    } catch (ex) {
      //console.log("Error:- " + ex);    
    }
    //console.log("Auth output: "+IsAuthorized);
    //return IsAuthorized;
},

getUserNameByUserID(Contacts,userPrincipalName) {
  var found = Contacts.find(
    (s) => s.userPrincipalName == userPrincipalName
  );
  if (found) return found.displayName;

  return userPrincipalName;
},

GetTaskCreatedEmailContent(Contacts,task)
{
  const MailHeader = "Excalibur Task Created";
  const MailMessage = "The following task has been created and assigned to you.";
  return this.GenerateHTMLContent('Created',MailHeader, MailMessage,this.getUserNameByUserID(Contacts,task.changedBy),task.templatename,task.collectionUnit,task.workflowDescription,this.getCurrentDuedate(task.listOfWorkflowStatus,task.currentStatus),task.currentStatus,task.changedAt);
},

GetTaskDeletedEmailContent(Contacts,task)
{
  const MailHeader = "Excalibur Task Deleted";
  const MailMessage = "The following task has been deleted.";
  return this.GenerateHTMLContent('Deleted',MailHeader, MailMessage,this.getUserNameByUserID(Contacts,task.changedBy),task.templatename,task.collectionUnit,task.workflowDescription,this.getCurrentDuedate(task.listOfWorkflowStatus,task.currentStatus),task.currentStatus,task.changedAt);
},
GenerateHTMLContent(Operation,MailHeader, MailMessage,user,templateName, collectionUnit,description,duedate,currentWorkflowStatus,changeOn ) {
  try {
    const TableBackgroundColor = '#EFEEEC';
    const MainHeaderBackgroundColor = '#2E86C1';
    const BorderColor = '#DBDAD8';
    const BannerHeader = "Excalibur";

    var html='<html><head><meta charset = "utf-8" /><meta name = "viewport" content = "width = device - width, initial - scale = 1.0"></head>';
    html=html+'<body><div class="container body-content"><center>'
    html=html+'<table width = "600" cellpadding="20" cellspacing="0" height="100%" bgcolor="'+ TableBackgroundColor + '" border="1" style="border-color:'+ BorderColor + '">';
    html=html+'<tbody><tr><th valign = "middle" bgcolor="'+ MainHeaderBackgroundColor + '"><center>';
    html=html+'<h1 style = "color:white; font-family:Algerian; font-weight:600;"><img src="https://excaliburspastorage.z19.web.core.windows.net/excalibur.png" width="32" height="32" alt="Excalibur"/>' + BannerHeader+'</h1>';
    html=html+ '<h3 style = "color:white;" >EXCel As LIghtweight BUsiness Reporting</h3></center></th></tr>';
    html=html+'<tr><td valign = "left">';
    html=html+'<h1>'+ MailHeader + ' </h1><p>Dear user,<br> '+MailMessage+'</p><h3 style = "font-family:Times New Roman;">Task Details: </h3>';
    html=html+'<table class="table table-striped table-bordered table-hover">';
    html=html+'<tr><td>Input form: </td><td>' + templateName + '</td></tr>';
    html=html+'<tr><td>Collection unit: </td><td>' + collectionUnit + '</td></tr>';
    html=html+'<tr><td>Description: </td><td>' + description + '</td></tr>';
    html=html+'<tr><td>Due date: </td><td>' + duedate + '</td></tr>';
    html=html+'<tr><td>Current status: </td><td>' + currentWorkflowStatus + '</td></tr>';
    html=html+'<tr><td>'+Operation+' by: </td><td>' + user + '</td></tr>';
    html=html+'<tr><td>'+Operation+' on: </td><td>' + changeOn + '</td></tr>';
    html=html+'</table></td></tr></tbody></table><hr/><footer><a href="https://excaliburspastorage.z19.web.core.windows.net/">Open Excalibur</a><p> &copy; 2020 - AVANT Corporation </p> </footer></center></div></body></html>';


    //html=html+'<h1>Excalibur task created </h1><p>Dear user,<br> The following task has been created and assigned to you.</p></body></html>'
    
    return html;

  }
  catch (ex) {
    console.log("Error : " + ex);
  }
},

getCurrentDuedate(workflowStatusData, currentStatus) {
  /*var Obj = [];
  workflowStatusData.forEach((element) =>
    Obj.push(
      Object.assign(
        {},
        ...Object.entries(element).map(([status, duedate]) => ({
          status,
          duedate,
        }))
      )
    )
  );*/
  var stages = workflowStatusData.map((item) => ({
    step: item.step,
    status: item.text,
    duedate: item.duedate,
    assignee: item.assignee,
  }));

  const found = stages.find((v) => v.status == currentStatus);
  if (found.step === stages.length - 1) {
    return "-";
  }
  return found.duedate;
},
  GetTaskUpdatedEmailContent(Contacts, task) {
    try {
      //const html='<html><body><h1>Excalibur task updated </h1><p>Dear user,<br> The task assigned to you has been updated.</p></body></html>'
      const MailHeader = "Excalibur Task Updated";
      const MailMessage = "The task assigned to you has been updated.";
      return this.GenerateHTMLContent('Updated', MailHeader, MailMessage, this.getUserNameByUserID(Contacts, task.changedBy), task.templatename, task.collectionUnit, task.workflowDescription, this.getCurrentDuedate(task.listOfWorkflowStatus, task.currentStatus), task.currentStatus, task.changedAt);
    }
    catch (ex) {
      console.log("Error : " + ex);
    }
  },

  shadeColor(color, percent) {

    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;  
    G = (G<255)?G:255;  
    B = (B<255)?B:255;  

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
},
getContrast (hexcolor){

	// If a leading # is provided, remove it
	if (hexcolor.slice(0, 1) === '#') {
		hexcolor = hexcolor.slice(1);
	}

	// If a three-character hexcode, make six-character
	if (hexcolor.length === 3) {
		hexcolor = hexcolor.split('').map(function (hex) {
			return hex + hex;
		}).join('');
	}

	// Convert to RGB value
	let r = parseInt(hexcolor.substr(0,2),16);
	let g = parseInt(hexcolor.substr(2,2),16);
	let b = parseInt(hexcolor.substr(4,2),16);

	// Get YIQ ratio
	let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return (yiq >= 128) ? false : true;

},


}



export default customFunctions